const initialModification = {
  guestName: "",
  guestEmail: "",
  guestNationality: "",
  specialRequest: "",
};

export { initialModification };
